import { readStoredString, writeStoredString } from '../utils/clientStorage';

export type ThemeKey = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'typewriter_theme_key';

const listeners = new Set<() => void>();

export function readStoredThemeKey(): ThemeKey {
  // Reads go through the safe clientStorage seam: a blocked or absent
  // localStorage (which can throw on property access, not just on methods)
  // degrades to the system default instead of crashing boot.
  const stored = readStoredString(STORAGE_KEY);
  return stored === 'light' || stored === 'dark' || stored === 'system' ? stored : 'system';
}

export function writeStoredThemeKey(themeKey: ThemeKey): void {
  writeStoredString(STORAGE_KEY, themeKey);
  listeners.forEach((listener) => listener());
}

export function subscribeThemeKey(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
